__turbopack_context__.v({
  "bar": "wzlsVG_bar",
  "label": "wzlsVG_label",
  "mark": "wzlsVG_mark",
  "markLabel": "wzlsVG_markLabel",
  "root": "wzlsVG_root",
  "thumb": "wzlsVG_thumb",
  "track": "wzlsVG_track",
});
